import React from "react";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";

const RulesPanel = ({ rulesMarkdown, loading, error }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        p: 1,
        overflow: "hidden",
      }}
    >
      <Typography variant="subtitle2" gutterBottom>
        Rules
      </Typography>

      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          fontFamily: "monospace",
          fontSize: "0.8rem",
          whiteSpace: "pre-wrap",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: "text.secondary",
            }}
          >
            <CircularProgress size={16} />
            <span>Loading rules…</span>
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error">
            Rules unavailable: {error}
          </Typography>
        ) : rulesMarkdown && rulesMarkdown.trim().length > 0 ? (
          <pre style={{ margin: 0 }}>{rulesMarkdown}</pre>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No rules available for this module.
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default RulesPanel;
